import { FC, AnchorHTMLAttributes } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import styled from 'styled-components';

interface IProps
  extends Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'> {
  isDisabled: boolean;
  type: 'up' | 'down';
}

const Block = styled.span`
  .disable > img {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const SortButton: FC<IProps> = ({ isDisabled, onClick, type }) => {
  const { isDarkMode } = useSelector((state: RootState) => state.auth);

  return (
    <>
      {type === 'up' ? (
        <a className={isDisabled ? 'btn-order up disabled' : 'btn-order up'} onClick={onClick} />
      ) : (
        <a className={isDisabled ? 'btn-order down disabled' : 'btn-order down'} onClick={onClick} />
      )}
    </>
  );
};

export default SortButton;
